/** Longest configured transition, including delay and CSS list repetition. */
export function modalTransitionDuration(
  style: Pick<CSSStyleDeclaration, 'transitionProperty' | 'transitionDuration' | 'transitionDelay'>
): number {
  const properties = style.transitionProperty.split(',').map((value) => value.trim());
  const durations = style.transitionDuration.split(',').map(milliseconds);
  const delays = style.transitionDelay.split(',').map(milliseconds);
  return Math.max(
    0,
    ...properties.map((property, index) =>
      property === 'none' ? 0 : durations[index % durations.length] + delays[index % delays.length]
    )
  );
}

function milliseconds(value: string): number {
  const time = Number.parseFloat(value);
  if (!Number.isFinite(time)) return 0;
  return value.trim().endsWith('ms') ? time : time * 1000;
}
